import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
} from '@apollo/orbit';
import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';

import { RouteConfig } from 'src/lib/routeConfig/RouteConfig';

import { proposalEditorRouteConfig } from '../../routes';

export const DiscardProposalEditorChangesModal = ({
  isOpen,
  onClose,
  discardUnsavedSubgraphChanges,
}: {
  isOpen: boolean;
  onClose: () => void;
  discardUnsavedSubgraphChanges: () => void;
}) => {
  const history = useHistory();
  const location = useLocation();

  const onSubmit = useCallback(async () => {
    discardUnsavedSubgraphChanges();
    onClose();
    history.push(
      proposalEditorRouteConfig.locationFrom({
        location,
        patch: {
          pullUpstreamChanges: RouteConfig.DELETE,
        },
      }),
    );
  }, [discardUnsavedSubgraphChanges, history, location, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Discard changes</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <div>
            Are you sure you want to discard all unsaved changes made in this
            schema?
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup>
            <Button
              variant="secondary"
              onClick={onClose}
              data-testid="reset-changes-cancel"
            >
              Keep editing
            </Button>
            <Button variant="primary" onClick={onSubmit}>
              Discard changes
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
